/**
 * useLabel hook
 * @returns {object}
 */
export const useLabel = () => {
    // todo: get from api

    // keep case
    return {
        // noStock: 'Není skladem',
        LBL_BAD_DATA: 'Zlé dáta',
        LBL_EMAIL_EXISTS: 'Email už existuje',
        LBL_EMAIL_SEND_FAILED: 'Vyskytla sa chyba EMF01',
        LBL_FORBIDDEN: 'Neoprávnená akcia',
        LBL_FORBIDDEN_PASSWD_CHANGE: 'Chybné pôvodné heslo',
        LBL_NOT_FONUD: 'Nebol nájdený',
        LBL_NO_EMAIL_TPL: 'Vyskytla sa chyba ENT01',
        LBL_REQUEST_EXISTS: 'Žiadosť s týmto emailom už existuje.',
        accept: 'Prijať',
        accepted: 'Prijaté',
        accessToB2B: 'Prístup do B2B sekcie',
        account: 'Účet',
        activeFilters: 'Aktívne filtre',
        addToCart: 'Pridať do košíka',
        address: 'adresa',
        alternativeProducts: 'Alternatívne produkty',
        back: 'Späť',
        backToHome: 'Späť na úvodnú stránku',
        backToLogin: 'Späť k autorizácii',
        backWheel: 'Zadné koleso',
        billingAddress: 'Fakturačná adresa',
        billingCompanyByUserBranch: 'Fakturačná firma podľa pobočky používateľa',
        brand: 'Značka',
        businessName: 'Firma',
        buyAgain: 'Kúpiť znova',
        byRequest: 'na dopyt',
        cancelFilters: 'Zrušiť filtre',
        fixQtyOrChangeDelivery: 'Prosím, upravte počet kusov alebo zmeňte spôsob doručenia.',
        cart: 'Nákupný košík',
        acceptTermsIsRequired: 'Je potrebné prijať obchodné podmienky',
        cartIsEmpty: 'Košík je prázdny',
        cartIsUpToDate: 'Košík aktualizovaný',
        cartNote: 'Poznámka k objednávke',
        cartNoteSecondary: '(Stroj, značka, typ, v.č.)',
        categories: 'Kategórie',
        changePassword: 'Zmeniť heslo',
        city: 'Mesto',
        company: 'Názov firmy',
        companyInfo: 'Firemné údaje',
        contactInfo: 'Kontaktné údaje',
        confirmOrder: 'Potvrdiť objednávku',
        contact: 'kontakt',
        contactPerson: 'Kontaktná osoba',
        contactForm: 'Kontaktný formulár - dopyt / odporúčanie',
        continue: 'Pokračovať',
        currency: '€', // if you’re switching currency too
        delivery: 'doručenie',
        deliveryAddress: 'Doručovacia adresa',
        discount: 'Zľava',
        doBindingOrder: 'Záväzne objednať',
        doLogin: 'Prihlásiť sa',
        doOrder: 'Objednať',
        doPrint: 'Vytlačiť',
        doSaveAddress: 'Uložiť adresu pre ďalšiu objednávku',
        doSaveContact: 'Uložiť kontakt pre ďalšiu objednávku',
        doSearch: 'Vyhľadať',
        doSort: 'Zoradiť',
        drop: 'Zmazať',
        dropCart: 'Vyprázdniť košík',
        email: 'Email',
        empty: 'prázdny',
        exportAsOffer: 'Stiahnuť ako ponuku',
        errorCaught1: 'Ospravedlňujeme sa',
        errorCaught2: 'vyskytla sa chyba',
        errorCaughtContent: 'Ospravedlňujeme sa, vyskytla sa chyba pri spracovaní akcie. <br/>Skúste to prosím znova. Ak problém pretrváva, <br/>neváhajte nás kontaktovať.',
        executionAddress: 'Adresa realizácie',
        fillForm: 'Vyplniť formulár',
        filtering: 'Filtrovanie',
        firstName: 'Meno',
        forgotPass: 'Zabudnuté heslo',
        frontWheel: 'Predné koleso',
        headerSalesContact: 'Váš obchodný zástupca',
        headerSalesContactButton: 'Kontaktovať',
        helpAndSupport: 'Pomoc a podpora',
        hideFilters: 'Skryť filtre',
        ico: 'IČO',
        installApp: 'Chcete nainštalovať aplikáciu na plochu?',
        installBtn: 'Inštalovať',
        installDate: 'termín montáže',
        installTire: 'Montáž pneu',
        internalNum: 'Interné číslo',
        invoices: 'Faktúry',
        jobTitle: 'Pracovná pozícia',
        label: 'Štítok',
        lastName: 'Priezvisko',
        lastSeen: 'Naposledy prezerané',
        limitedStock: 'obmedzené množstvo',
        loading: 'Načítavanie',
        login: 'Prihlásenie',
        loginErr: 'Chyba autorizácie',
        logout: 'Odhlásiť sa',
        manufacturer: 'Výrobca',
        manufacturerNum: 'Výrobné číslo',
        message: 'Správa',
        model: 'Model',
        myOrders: 'Moje objednávky',
        myAccount: 'Môj účet',
        newPass: 'Nové heslo',
        newPassword: 'Nové heslo',
        newPasswordRepeat: 'Nové heslo znova',
        noAttachments: 'Žiadne prílohy',
        noAttrsSelected: 'Neboli nájdené žiadne atribúty',
        noInvoices: 'Žiadne faktúry',
        noOrders: 'Žiadne objednávky',
        noProducts: 'Žiadne produkty',
        noResults: 'Žiadne výsledky',
        noStock: 'nie je skladom',
        noVat: 'bez DPH',
        note: 'Poznámka',
        offerFillMachineRequest: 'Neviete nájsť požadovaný tovar? Zadajte dopyt na doručenie!',
        oldPassword: 'Staré heslo',
        onSale: 'výpredaj',
        order: 'Objednávka',
        orderAccount: 'Objednávateľ - firma',
        orderAdditionalInfoIsUploading: 'Nahrávanie dodatočných informácií o objednávke...',
        orderAgain: 'Objednať znova',
        orderBranch: 'Objednávateľ - pobočka',
        orderContact: 'Kontakt',
        orderCreatePending: 'vytváranie',
        orderCreatedBy: 'Vytvoril',
        orderCreatedDate: 'Vystavené',
        orderEnteredDate: 'Vytvorené',
        orderInfoIsUploading: 'Nahrávanie informácií o objednávke...',
        orderIsSent: 'Vaša objednávka bola odoslaná',
        orderSendError: 'Vyskytla sa chyba pri odosielaní objednávky',
        orderSummary: 'Rekapitulácia objednávky',
        orders: 'Objednávky',
        pageNotFound: 'Stránka nenájdená',
        pageNotFoundContent: 'Ospravedlňujeme sa, ale stránka, ktorú hľadáte, <br/>nebola nájdená.',
        parameters: 'Parametre',
        password: 'Heslo',
        passwordMustContainNumber: 'Heslo musí obsahovať aspoň jedno číslo',
        passwordMustContainUppercase: 'Heslo musí obsahovať aspoň jedno veľké písmeno',
        passwordRepeat: 'Zopakujte heslo',
        passwordTooShort: 'Heslo je príliš krátke (min. 8 znakov)',
        passwordWasSet: 'Heslo bolo nastavené',
        passwordsDoNotMatch: 'Heslá sa nezhodujú',
        phone: 'Telefónne číslo',
        postalCode: 'PSČ',
        price: 'Cena',
        priceCurrentNoVat: 'Cena bez DPH',
        pricePrev: 'Pôvodná cena',
        productCodeShort: 'Kat. č.',
        profile: 'Profil',
        purpose: 'Náprava',
        qty: 'ks',
        recommendedProducts: 'Odporúčané produkty',
        requestForProduct: 'Dopyt na produkt',
        requestTitle: 'Požiadať o prístup do B2B sekcie',
        requiredField: 'Vyplňte všetky povinné polia',
        resetPass: 'Reset hesla',
        resultsIsUpdated: 'Výsledky boli aktualizované',
        sale: 'AKCIA',
        save: 'Uložiť',
        saveError: 'Vyskytla sa chyba pri ukladaní',
        saved: 'Uložené',
        saving: 'Ukladanie',
        searchProducts: 'Vyhľadať produkty',
        searchResults: 'Výsledky vyhľadávania',
        selectSavedAddress: 'Vybrať uloženú adresu',
        selectSavedContact: 'Vybrať uložený kontakt',
        selectWeek: 'Vybrať týždeň',
        selfPickup: 'Osobný odber',
        sendRequest: 'Odoslať požiadavku',
        serviceOrderDate: 'Dátum montáže',
        serviceOrderPrint: 'Servisný výkaz',
        serviceOrders: 'Servisné objednávky',
        serviceOrdersBtn: 'Servisné obj.',
        setFilters: 'Nastaviť filtre',
        shippingAccount: 'Koncový zákazník - firma',
        shippingBranch: 'Koncový zákazník - pobočka',
        showCatalog: 'Zobraziť katalóg',
        showLess: 'zobraziť menej',
        showMore: 'zobraziť viac',
        showSelect: 'Podľa stroja',
        sideBack: 'Zadné',
        sideFront: 'Predné',
        specify: 'Upresniť',
        state: 'Štát',
        stepBack: 'Späť',
        stock: 'skladom',
        street: 'Ulica a číslo domu',
        terms1: 'Všeobecné obchodné podmienky',
        terms2: 'Spracovanie osobných údajov',
        total: 'Celkom',
        totalNoVat: 'Medzisúčet (bez DPH)',
        totalVat: 'DPH (23%)',
        totalWithVat: 'Celková suma',
        tryAgain: 'Skúsiť znova',
        unknown: 'neznámy',
        upload: 'nahrať',
        uploadImage: 'nahrať obrázok',
        userProfileHeadline: 'Môj účet',
        userSettings: 'Nastavenia používateľa',
        userSettingsShort: 'Nastavenia',
        welcomeWish: 'Prajeme príjemný nákup v našom B2B eshope.',
        whole: 'Celok',
        withVat: 's DPH',
    };
};
